import { render } from "./AppHeaders.vue?vue&type=template&id=3cdc18bf&scoped=true"
import script from "./AppHeaders.vue?vue&type=script&lang=js"
export * from "./AppHeaders.vue?vue&type=script&lang=js"

import "./AppHeaders.vue?vue&type=style&index=0&id=3cdc18bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cdc18bf"]])

export default __exports__